module.exports = __webpack_public_path__ + "be732f98a5e21c6b610e4fea5e3b88a9.pdf";